import "./contas.css";
import Footer from "./footer";
import RevealTitle from "./RevealTitle";
import { motion } from "framer-motion";

const SOCIALS = [
    { label: "LinkedIn", url: "https://www.linkedin.com/in/mohammed-swalih-a560951ba/" },
    { label: "GitHub", url: "https://github.com/mohammed0Swalih" },
    { label: "Instagram", url: "https://www.instagram.com/itsme_swalih/?hl=en" },
];

const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.25, 0.1, 0.25, 1] } },
};

export default function Contas() {
    return (
        <>
            <section className="section contactHead">
                <h3 className="sec-label">Contact</h3>
                <RevealTitle text="Get in touch" className="contactTitle" />
                <motion.p className="contactStatement"
                    variants={fadeUp} initial="hidden" animate="visible">
                    Reach out to talk <span className="mute">AI, collaborate on a project</span>, or simply to say hello.
                </motion.p>
            </section>

            <section className="section contactGrid">
                <motion.div className="contactCol"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                    <h4 className="contactColLabel">Get in touch</h4>
                    <a className="contactEmail" href="mailto:swalih3409@gmail.com">
                        swalih3409@gmail.com <span className="arw">↗</span>
                    </a>
                    <div className="contactAddress">
                        <h4 className="contactColLabel">Location</h4>
                        <p>Kottayam, Kerala — India</p>
                    </div>
                </motion.div>

                <motion.div className="contactCol"
                    variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }}>
                    <h4 className="contactColLabel">Find me on</h4>
                    <ul className="contactSocials">
                        {SOCIALS.map((s) => (
                            <li key={s.label}>
                                <a href={s.url} target="_blank" rel="noreferrer">
                                    <span>{s.label}</span>
                                    <span className="arw">↗</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </motion.div>
            </section>

            <Footer />
        </>
    );
}
